import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpOperatorFormData } from "../types";

export const BusinessTradingNameField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Business Trading Name</Typography>
      <TextInput
        className="w-full"
        placeholder="Enter Company Trading Name"
        maxLength={45}
        hasError={!!errors.businessTradingName}
        {...register("businessTradingName")}
      />
      <ErrorMessage errors={errors} name="businessTradingName" />
    </div>
  );
};
